var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "0 0 9600 4800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v6H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.5h8V4zm6 0H3v4h-5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(800)",
    strokeWidth: 0.6,
    fill: "#012169",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 0l6 3M0 3l6-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 0.4,
    clipPath: "url(#b)",
    d: "M0 0l6 3M0 3l6-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    d: "M3 0v4M0 1.5h7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    d: "M3 0v4M0 1.5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3h6V0h6v6H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7200 2400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    fill: "#fff",
    d: "M0-1992l81 249h261l-211 153 81 249L0-1494l-212 153 81-249-211-153h261z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(24)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(48)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(216)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(288)",
    xlinkHref: "#d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.29fcbe6616e3be280472d49e5540ac86.svg";
export { ForwardRef as ReactComponent };